import { render, staticRenderFns } from "./MailServer.vue?vue&type=template&id=603b1ed8"
import script from "./MailServer.vue?vue&type=script&lang=js"
export * from "./MailServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603b1ed8')) {
      api.createRecord('603b1ed8', component.options)
    } else {
      api.reload('603b1ed8', component.options)
    }
    module.hot.accept("./MailServer.vue?vue&type=template&id=603b1ed8", function () {
      api.rerender('603b1ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MailServer.vue"
export default component.exports